import { useState } from "react";
import type { FormEvent } from "react";
import useFormSubmit from "@/hooks/useFormSubmit";

const topics = ["事件线索", "内容纠错", "授权与引用", "合作咨询"];

export default function ContactForm() {
  const { status, message, submit } = useFormSubmit();
  const [messageLength, setMessageLength] = useState(0);
  const maxMessage = 500;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    submit(form, "phone_alt", "留言已提交，编辑会在两个工作日内回复。");
  };

  const inputClass =
    "w-full h-11 px-3.5 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100";

  return (
    <form
      id="contact-form-1"
      data-readdy-form
      action="https://readdy.ai/api/form/dahg50jp14a1h3mr6ll0"
      onSubmit={handleSubmit}
      className="w-full p-5 md:p-7 rounded-lg bg-background-50 border border-background-200"
    >
      <h2 className="font-heading font-bold text-xl text-foreground-950 mb-1">在线留言</h2>
      <p className="text-sm text-foreground-600 mb-6">
        提供事件线索，或指出内容中的错误。信息越具体，我们核对得越快。
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <label className="flex flex-col gap-1.5">
          <span className="text-xs text-foreground-700">称呼 <span className="text-primary-600">*</span></span>
          <input type="text" name="name" required maxLength={60} placeholder="怎么称呼你" className={inputClass} />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-xs text-foreground-700">邮箱 <span className="text-primary-600">*</span></span>
          <input type="email" name="email" required maxLength={120} placeholder="用于接收回复" className={inputClass} />
        </label>
      </div>

      <label className="flex flex-col gap-1.5 mt-4">
        <span className="text-xs text-foreground-700">留言类型 <span className="text-primary-600">*</span></span>
        <select name="topic" required defaultValue="" className={inputClass}>
          <option value="" disabled>
            请选择类型
          </option>
          {topics.map((topic) => (
            <option key={topic} value={topic}>
              {topic}
            </option>
          ))}
        </select>
      </label>

      <label className="flex flex-col gap-1.5 mt-4">
        <span className="text-xs text-foreground-700">留言内容 <span className="text-primary-600">*</span></span>
        <textarea
          name="message"
          required
          maxLength={maxMessage}
          rows={5}
          onChange={(event) => setMessageLength(event.target.value.length)}
          placeholder="请描述事件名称、发生时间和你的依据来源"
          className="w-full p-3.5 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 resize-none"
        ></textarea>
      </label>
      <p className="mt-1.5 text-[11px] text-foreground-400 text-right">
        {messageLength}/{maxMessage}
      </p>

      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="hp-alt-field"
      />

      <div className="mt-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-foreground-500">我们承诺不会将你的邮箱用于其他用途。</p>
        <button
          type="submit"
          disabled={status === "submitting"}
          className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer flex items-center gap-1.5"
        >
          <i className="ri-send-plane-line"></i>
          {status === "submitting" ? "提交中..." : "提交留言"}
        </button>
      </div>

      {message && (
        <p
          className={`mt-3 text-sm ${status === "error" ? "text-primary-700" : "text-secondary-700"}`}
          role="status"
        >
          {message}
        </p>
      )}
    </form>
  );
}